import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    avatarListLoading: false,
    avatarListSuccess: null,
    avatarListError: '',
    editAvatarDataLoading: false,
    editAvatarDataSuccess: null,
    editAvatarDataError: '',
    getAvatarLoading: false,
    getAvatarSuccess: null,
    getAvatarError: '',
}

export const avatarSlice = createSlice ({
    name: 'avatar',
    initialState,
    reducers: {
        setAvatarListLoading: (state) => {
            state.avatarListLoading = true;
            state.avatarListSuccess = null;
            state.avatarListError = '';
        },
        setAvatarListSuccess: (state, action) => {
            state.avatarListLoading = false;
            state.avatarListSuccess = action.payload;
            state.avatarListError = '';
        },
        setAvatarListError: (state, action) => {
            state.avatarListLoading = false;
            state.avatarListSuccess = null;
            state.avatarListError = action.payload;
        },
        setEditAvatarDataLoading: (state) => {
            state.editAvatarDataLoading = true;
            state.editAvatarDataSuccess = null;
            state.editAvatarDataError = '';
        },
        setEditAvatarDataSuccess: (state, action) => {
            state.editAvatarDataLoading = false;
            state.editAvatarDataSuccess = action.payload;
            state.editAvatarDataError = '';
        },
        setEditAvatarDataError: (state) => {
            state.editAvatarDataLoading = false;
            state.editAvatarDataSuccess = null;
            state.editAvatarDataError = null;
        },
        setGetAvatarLoading: (state) => {
            state.getAvatarLoading = true;
            state.getAvatarSuccess = null;
            state.getAvatarError = "";
        },
        setGetAvatarSuccess: (state, action) => {
            state.getAvatarLoading = false;
            state.getAvatarSuccess = action.payload;
            state.getAvatarError = '';
        },
        setGetAvatarError: (state, action) => {
            state.getAvatarLoading = false;
            state.getAvatarSuccess = null;
            state.getAvatarError = action.payload;
        },

        resetAvatarDetails: (state) => {
            state.getAvatarSuccess = {};
            state.editAvatarDataSuccess = {};
        }
    }
})

export const {setAvatarListLoading, setAvatarListSuccess, setAvatarListError, 
    setEditAvatarDataLoading, setEditAvatarDataSuccess, setEditAvatarDataError,
    setGetAvatarLoading, setGetAvatarSuccess, setGetAvatarError, resetAvatarDetails } = avatarSlice.actions

export default avatarSlice.reducer